/**
 * Copied from global-variables.less
 *
 * Similar to the less paradigm we had, we should never define colors inside our components
 * Instead, import the specific color into your component for in-line styling use
 */

const Colors = {
  // PRIMARY
  '@white': '#fff',
  '@white-lilac': '#f7f9fc',
  '@sky': '#8dbee7',
  '@java': '#0075c9',
  '@eastern-blue': '#004876',
  '@deep-cerulean': '#007ea8',
  '@navy-blue': '#303654',
  '@black-pearl': '#06122f',

  // NEW DESIGN COLORS
  '@link-water': '#d4e4f5',
  '@matisse': '#356189',
  '@chetwode-blue': '#7e8eda',
  '@eucalyptus': '#01c0aa',
  '@cornflower-blue': '#4992e3',
  '@radical-red': '#f14858',
  '@tundora': '#4e5760',
  '@east-side': '#b388cb',
  '@gray-chateau': '#9EA2A7',

  // EXTENDED
  '@athens-gray': '#f2f3f7',
  '@mystic': '#e0e6ec',
  '@dove-gray': '#c2ccd7',
  '@heather': '#b5c0cd',
  '@bali-hai': '#93a5ba',
  '@lynch': '#677c94',
  '@slate-gray': '#748292',
  '@ash-gray': '#607184',
  '@east-bay': '#444c6d',
  '@ghost': '#f9f9fb',
  '@alabaster': '#fafafa',
  '@wind-sand': '#f5f5f5',
  '@gallery': '#eee',
  '@alto': '#cecece',
  '@boulder': '#777',
  '@tundora-old': '#444',
  '@mine-shaft': '#333',
  '@bright-gray': '#3b3e49',
  '@solitude': '#e9edf1',
  '@mishka': '#cfd2de',
  '@waterloo': '#797c8c',
  '@storm-gray': '#72778d',
  '@pickled-bluewood': '#2e4054',
  '@midnight': '#24283e',
  '@deep-sky-blue': '#02bbf1',

  // ACTION
  '@jungle-green': '#28b37f',
  '@mountain-meadow': '#1fb955',
  '@saffron-mango': '#faba5f',
  '@yellow-orange': '#ffba43',
  '@orange-peel': '#ff9e16',
  '@salmon': '#ff988a',
  '@sunglo': '#e37978',
  '@persion-red': '#d43c3a',
  '@grape': '#4c215e',
  '@deep-lilac': '#8b41af',

  // OTHER
  '@transparent': 'transparent'
};

export default Colors;
